import React from "react";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import "./PastQuestions.css";

const syllabusData = [
  {
    level: "Level 1",
    subjects: [
      { code: "L1-PAS", title: "Probability & Mathematical Statistic", pdf: "ASG L1-PAS Probability & Actuarial Stats 2025.pdf" },
      { code: "L1-AE", title: "Actuarial Economics", pdf: "ASG L1-AE Actuarial Economic 2025.pdf" },
      { code: "L1-AFR", title: "Actuarial Financial Reporting", pdf: "ASG L1-AFR Actuarial Financial Reporting 2025.pdf" },
    ],
  },
  {
    level: "Level 2",
    subjects: [
      { code: "L2-FM", title: "Financial Mathematics", pdf: "ASG L2-FM Financial Mathematics 2025.pdf" },
      { code: "L2-RSS", title: "Risk & Survival Statistic", pdf: "ASG L2-RSS Risk & Survival Statistics 2025.pdf" },
    ],
  },
];

const Syllabus = () => {
  const navigate = useNavigate();

  const handleCardClick = (subject) => {
    Swal.fire({
      title: `Download Syllabus?`,
      text: `You're about to download the syllabus for ${subject.title}. Proceed?`,
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Download",
    }).then((result) => {
      if (result.isConfirmed) {
        const link = document.createElement("a");
        link.href = `/Past-Questions/Syllabus/${subject.pdf}`;
        link.download = subject.pdf;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    });
  };

  const goToPastQuestions = () => {
    navigate("/past-questions");
  };

  return (
    <div>
      <section className="section-council">
        <div className="sectiontop-line"></div>
        <h2 className="sectiontitle">SYLLABUS</h2>
        <div className="sectionbottom-line"></div>
      </section>
<div className="card-seperation">
      <div className="past-questions-container">
        {syllabusData.map((group, index) => (
          <div key={index} className="level-section">
            <h3 className="level-title">{group.level}</h3>
            <div className="card-row">
              <div className="card-grid">
                {group.subjects.map((subject, idx) => (
                  <div key={idx} className="card1" onClick={() => handleCardClick(subject)}>
                    <h4 className="code">{subject.code}</h4>
                    <p className="subject">{subject.title}</p>
                  </div>
                ))}
               </div>
               </div>
          </div>
        ))}
        </div>


              {/* Past Questions card as a separate section on the right */}
              <div className="past-questions-column">
                <div className="card past-question-card" onClick={goToPastQuestions}>
                  <h4 className="code">PAST QUESTIONS</h4>
                  <p className="subject">Click here to view past questions</p>
                </div>
            </div>
    </div>
    </div>
  );
};

export default Syllabus;
